// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backend-detail-container {
  padding: 1rem;
  height: calc(100% - 32px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  gap: 1rem;
  color: var(--text-secondary);
}

.error-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: var(--error-bg, rgba(244, 67, 54, 0.1));
  border-radius: 8px;
  color: var(--error-color, #f44336);
  margin-bottom: 1rem;
}
.error-message mat-icon {
  flex-shrink: 0;
}
.error-message span {
  flex: 1;
}

.detail-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.detail-content::-webkit-scrollbar {
  width: 8px;
}
.detail-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}
.detail-content::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.detail-content::-webkit-scrollbar-thumb:hover {
  background: rgba(175, 175, 175, 0.9);
}

.backend-description {
  color: var(--text-secondary);
  margin-bottom: 1.5rem;
}

.status-section {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}
.status-section h3 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  font-weight: 500;
}
.status-section .status-row {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}
.status-section .status-row .status-label {
  color: var(--text-secondary);
  min-width: 120px;
}
.status-section .status-row .status-loading-value {
  color: var(--text-secondary);
  font-style: italic;
}
.status-section .status-row .status-ok {
  color: var(--success-color, #4caf50);
}
.status-section .status-row .status-warning {
  color: var(--warning-color, #ff9800);
}
.status-section button {
  margin-top: 1rem;
}

.config-section {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}
.config-section h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  font-weight: 500;
}
.config-section p {
  color: var(--text-secondary);
  font-size: 0.875rem;
  margin: 0 0 1rem 0;
}
.config-section .full-width {
  width: 100%;
  margin-bottom: 1rem;
}
.config-section .get-key-button {
  margin-bottom: 1rem;
}
.config-section .get-key-button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: 0.5rem;
}

.cli-instructions .cli-buttons {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}
.cli-instructions .cli-buttons button mat-icon {
  margin-right: 0.5rem;
}

.cli-output {
  background: var(--code-bg, #1e1e1e);
  border-radius: 8px;
  padding: 1rem;
  overflow-x: auto;
}
.cli-output pre {
  margin: 0;
  font-family: "Fira Code", "Consolas", monospace;
  font-size: 0.8rem;
  line-height: 1.5;
  color: var(--code-text, #d4d4d4);
  white-space: pre-wrap;
  word-break: break-word;
}

.models-section {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1rem;
}
.models-section h3 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  font-weight: 500;
}
.models-section .model-chips mat-chip {
  font-size: 0.75rem;
}

button mat-spinner {
  display: inline-block;
  margin-right: 0.5rem;
}

.auth-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  color: var(--text-secondary);
}
.auth-loading mat-spinner {
  flex-shrink: 0;
}

.auth-prompt .auth-description {
  color: var(--text-secondary);
  margin-bottom: 1rem;
  line-height: 1.5;
}
.auth-prompt .auth-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--error-bg, rgba(244, 67, 54, 0.1));
  border-radius: 8px;
  color: var(--error-color, #f44336);
  margin-bottom: 1rem;
  font-size: 0.875rem;
}
.auth-prompt .auth-error mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.auth-prompt .auth-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
}
.auth-prompt .auth-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.auth-prompt .auth-note {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  color: var(--text-secondary);
  font-size: 0.8rem;
}
.auth-prompt .auth-note mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.7;
}

.auth-progress .auth-starting {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
  text-align: center;
}
.auth-progress .auth-starting .auth-status-text {
  margin: 1rem 0 0.5rem;
  font-size: 1rem;
  color: var(--text-primary);
}
.auth-progress .auth-waiting {
  padding: 1rem 0;
}
.auth-progress .auth-waiting .auth-instructions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0 0 0.75rem 0;
  font-size: 0.9rem;
  color: var(--text-primary);
}
.auth-progress .auth-waiting .auth-instructions mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--success-color, #4caf50);
}
.auth-progress .auth-waiting .auth-code-field {
  margin-top: 1rem;
}
.auth-progress .auth-waiting .auth-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--error-bg, rgba(244, 67, 54, 0.1));
  border-radius: 8px;
  color: var(--error-color, #f44336);
  margin-bottom: 1rem;
  font-size: 0.875rem;
}
.auth-progress .auth-waiting .auth-error mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.auth-progress .auth-waiting .auth-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
}
.auth-progress .auth-waiting .auth-actions button mat-spinner {
  margin-right: 0.5rem;
}

.auth-success {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--success-bg, rgba(76, 175, 80, 0.1));
  border-radius: 8px;
  color: var(--success-color, #4caf50);
  margin-bottom: 1rem;
}
.auth-success .success-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.auth-expired {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--error-bg, rgba(244, 67, 54, 0.1));
  border-radius: 8px;
  color: var(--error-color, #f44336);
  margin-bottom: 1rem;
}
.auth-expired .expired-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.token-details {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.8rem;
}
.token-details .token-detail-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.token-details .token-detail-row:last-child {
  margin-bottom: 0;
}
.token-details .token-detail-row .detail-label {
  color: var(--text-secondary);
  min-width: 60px;
}
.token-details .token-detail-row .detail-value {
  color: var(--text-primary);
}
.token-details .token-detail-row .detail-value.expiring-soon {
  color: var(--warning-color, #ff9800);
}
.token-details .token-detail-row .detail-value.scopes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}
.token-details .token-detail-row .scope-chip {
  background: var(--neutral-bg, rgba(128, 128, 128, 0.15));
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  font-family: "Fira Code", "Consolas", monospace;
  font-size: 0.7rem;
}

.advanced-option {
  margin-top: 1.5rem;
}
.advanced-option mat-expansion-panel {
  background: transparent;
  box-shadow: none;
  border: 1px solid var(--border-color);
}
.advanced-option mat-expansion-panel mat-expansion-panel-header {
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.device-auth-info {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1rem;
  margin: 1rem 0;
}
.device-auth-info .device-url-row,
.device-auth-info .device-code-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
.device-auth-info .device-url-row:last-of-type,
.device-auth-info .device-code-row:last-of-type {
  margin-bottom: 0;
}
.device-auth-info .device-url-row .device-label,
.device-auth-info .device-code-row .device-label {
  color: var(--text-secondary);
  font-size: 0.8rem;
  min-width: 40px;
}
.device-auth-info .device-url-row .device-url,
.device-auth-info .device-code-row .device-url {
  color: var(--link-color, #2196f3);
  font-size: 0.875rem;
  text-decoration: none;
  word-break: break-all;
}
.device-auth-info .device-url-row .device-url:hover,
.device-auth-info .device-code-row .device-url:hover {
  text-decoration: underline;
}
.device-auth-info .device-url-row .device-code,
.device-auth-info .device-code-row .device-code {
  font-family: "Fira Code", "Consolas", monospace;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--primary-color, #1976d2);
  letter-spacing: 0.1em;
  background: var(--code-bg, rgba(0, 0, 0, 0.1));
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
}
.device-auth-info .device-url-row button,
.device-auth-info .device-code-row button {
  flex-shrink: 0;
}
.device-auth-info .device-note {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin: 1rem 0 0 0;
  color: var(--text-secondary);
  font-size: 0.8rem;
  line-height: 1.4;
}
.device-auth-info .device-note mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 2px;
  opacity: 0.7;
}

.auth-instructions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0 0 0.75rem 0;
  font-size: 0.9rem;
  color: var(--text-primary);
}
.auth-instructions mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--success-color, #4caf50);
  flex-shrink: 0;
}

.auth-code-field {
  margin-top: 1rem;
}

.auth-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--error-bg, rgba(244, 67, 54, 0.1));
  border-radius: 8px;
  color: var(--error-color, #f44336);
  margin-bottom: 1rem;
  font-size: 0.875rem;
}
.auth-error mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.auth-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
}
.auth-actions button mat-spinner {
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/backend-detail-widget/backend-detail-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,4BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mDAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AACF;AACE;EACE,cAAA;AACJ;AAEE;EACE,OAAA;AAAJ;;AAIA;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qDAAA;AADF;AAGE;EACE,UAAA;AADJ;AAIE;EACE,uBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,oCAAA;EACA,kBAAA;AAHJ;AAKI;EACE,oCAAA;AAHN;;AAQA;EACE,4BAAA;EACA,qBAAA;AALF;;AAQA;EACE,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AALF;AAOE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AALJ;AAQE;EACE,aAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;AANJ;AAQI;EACE,4BAAA;EACA,gBAAA;AANN;AASI;EACE,4BAAA;EACA,kBAAA;AAPN;AAUI;EACE,oCAAA;AARN;AAWI;EACE,oCAAA;AATN;AAaE;EACE,gBAAA;AAXJ;;AAeA;EACE,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAZF;AAcE;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;AAZJ;AAeE;EACE,4BAAA;EACA,mBAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,WAAA;EACA,mBAAA;AAdJ;AAiBE;EACE,mBAAA;AAfJ;AAiBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAfN;;AAqBE;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,oBAAA;AAlBN;;AAuBA;EACE,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AApBF;AAsBE;EACE,SAAA;EACA,+CAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,qBAAA;EACA,sBAAA;AApBJ;;AAwBA;EACE,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;AArBF;AAuBE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AArBJ;AAyBI;EACE,kBAAA;AAvBN;;AA8BE;EACE,qBAAA;EACA,oBAAA;AA3BJ;;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;AA7BF;AA+BE;EACE,cAAA;AA7BJ;;AAkCE;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;AA/BJ;AAkCE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,mDAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,mBAAA;AAhCJ;AAkCI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAhCN;AAoCE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AAlCJ;AAoCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlCN;AAsCE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,iBAAA;AApCJ;AAsCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AApCN;;AA0CE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAvCJ;AAyCI;EACE,qBAAA;EACA,eAAA;EACA,0BAAA;AAvCN;AA2CE;EACE,eAAA;AAzCJ;AA2CI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,0BAAA;AAzCN;AA2CM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AAzCR;AA6CI;EACE,gBAAA;AA3CN;AA8CI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,mDAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,mBAAA;AA5CN;AA8CM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA5CR;AAgDI;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AA9CN;AAgDM;EACE,oBAAA;AA9CR;;AAoDA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,qDAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;AAjDF;AAmDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAjDJ;;AAqDA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mDAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAlDF;AAoDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlDJ;;AAsDA;EACE,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAnDF;AAqDE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AAnDJ;AAqDI;EACE,gBAAA;AAnDN;AAsDI;EACE,4BAAA;EACA,eAAA;AApDN;AAuDI;EACE,0BAAA;AArDN;AAuDM;EACE,oCAAA;AArDR;AAwDM;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAtDR;AA0DI;EACE,wDAAA;EACA,uBAAA;EACA,kBAAA;EACA,+CAAA;EACA,iBAAA;AAxDN;;AA6DA;EACE,kBAAA;AA1DF;AA4DE;EACE,uBAAA;EACA,gBAAA;EACA,qCAAA;AA1DJ;AA4DI;EACE,mBAAA;EACA,4BAAA;AA1DN;;AAgEA;EACE,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AA7DF;AA+DE;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AA7DJ;AA+DI;;EACE,gBAAA;AA5DN;AA+DI;;EACE,4BAAA;EACA,iBAAA;EACA,eAAA;AA5DN;AA+DI;;EACE,iCAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;AA5DN;AA8DM;;EACE,0BAAA;AA3DR;AA+DI;;EACE,+CAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,qBAAA;EACA,8CAAA;EACA,wBAAA;EACA,kBAAA;AA5DN;AA+DI;;EACE,cAAA;AA5DN;AAgEE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;AA9DJ;AAgEI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AA9DN;;AAoEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,0BAAA;AAjEF;AAmEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;AAjEJ;;AAqEA;EACE,gBAAA;AAlEF;;AAqEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,mDAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,mBAAA;AAlEF;AAoEE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAlEJ;;AAsEA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AAnEF;AAqEE;EACE,oBAAA;AAnEJ","sourcesContent":[".backend-detail-container {\n  padding: 1rem;\n  height: calc(100% - 32px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  gap: 1rem;\n  color: var(--text-secondary);\n}\n\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem;\n  background: var(--error-bg, rgba(244, 67, 54, 0.1));\n  border-radius: 8px;\n  color: var(--error-color, #f44336);\n  margin-bottom: 1rem;\n\n  mat-icon {\n    flex-shrink: 0;\n  }\n\n  span {\n    flex: 1;\n  }\n}\n\n.detail-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(175, 175, 175, 0.9);\n    }\n  }\n}\n\n.backend-description {\n  color: var(--text-secondary);\n  margin-bottom: 1.5rem;\n}\n\n.status-section {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n\n  h3 {\n    margin: 0 0 1rem 0;\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  .status-row {\n    display: flex;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n    font-size: 0.875rem;\n\n    .status-label {\n      color: var(--text-secondary);\n      min-width: 120px;\n    }\n\n    .status-loading-value {\n      color: var(--text-secondary);\n      font-style: italic;\n    }\n\n    .status-ok {\n      color: var(--success-color, #4caf50);\n    }\n\n    .status-warning {\n      color: var(--warning-color, #ff9800);\n    }\n  }\n\n  button {\n    margin-top: 1rem;\n  }\n}\n\n.config-section {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n\n  h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  p {\n    color: var(--text-secondary);\n    font-size: 0.875rem;\n    margin: 0 0 1rem 0;\n  }\n\n  .full-width {\n    width: 100%;\n    margin-bottom: 1rem;\n  }\n\n  .get-key-button {\n    margin-bottom: 1rem;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      margin-right: 0.5rem;\n    }\n  }\n}\n\n.cli-instructions {\n  .cli-buttons {\n    display: flex;\n    gap: 0.75rem;\n    margin-top: 1rem;\n    flex-wrap: wrap;\n\n    button mat-icon {\n      margin-right: 0.5rem;\n    }\n  }\n}\n\n.cli-output {\n  background: var(--code-bg, #1e1e1e);\n  border-radius: 8px;\n  padding: 1rem;\n  overflow-x: auto;\n\n  pre {\n    margin: 0;\n    font-family: 'Fira Code', 'Consolas', monospace;\n    font-size: 0.8rem;\n    line-height: 1.5;\n    color: var(--code-text, #d4d4d4);\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n}\n\n.models-section {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 1rem;\n\n  h3 {\n    margin: 0 0 1rem 0;\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  .model-chips {\n    mat-chip {\n      font-size: 0.75rem;\n    }\n  }\n}\n\n// Button with spinner\nbutton {\n  mat-spinner {\n    display: inline-block;\n    margin-right: 0.5rem;\n  }\n}\n\n// Claude Auth Wizard Styles\n.auth-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  color: var(--text-secondary);\n\n  mat-spinner {\n    flex-shrink: 0;\n  }\n}\n\n.auth-prompt {\n  .auth-description {\n    color: var(--text-secondary);\n    margin-bottom: 1rem;\n    line-height: 1.5;\n  }\n\n  .auth-error {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    background: var(--error-bg, rgba(244, 67, 54, 0.1));\n    border-radius: 8px;\n    color: var(--error-color, #f44336);\n    margin-bottom: 1rem;\n    font-size: 0.875rem;\n\n    mat-icon {\n      flex-shrink: 0;\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .auth-button {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    font-size: 1rem;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .auth-note {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-top: 1rem;\n    color: var(--text-secondary);\n    font-size: 0.8rem;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      opacity: 0.7;\n    }\n  }\n}\n\n.auth-progress {\n  .auth-starting {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 2rem 1rem;\n    text-align: center;\n\n    .auth-status-text {\n      margin: 1rem 0 0.5rem;\n      font-size: 1rem;\n      color: var(--text-primary);\n    }\n  }\n\n  .auth-waiting {\n    padding: 1rem 0;\n\n    .auth-instructions {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n      margin: 0 0 0.75rem 0;\n      font-size: 0.9rem;\n      color: var(--text-primary);\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        color: var(--success-color, #4caf50);\n      }\n    }\n\n    .auth-code-field {\n      margin-top: 1rem;\n    }\n\n    .auth-error {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      padding: 0.75rem 1rem;\n      background: var(--error-bg, rgba(244, 67, 54, 0.1));\n      border-radius: 8px;\n      color: var(--error-color, #f44336);\n      margin-bottom: 1rem;\n      font-size: 0.875rem;\n\n      mat-icon {\n        flex-shrink: 0;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n    }\n\n    .auth-actions {\n      display: flex;\n      gap: 0.75rem;\n      margin-top: 1rem;\n\n      button mat-spinner {\n        margin-right: 0.5rem;\n      }\n    }\n  }\n}\n\n.auth-success {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: var(--success-bg, rgba(76, 175, 80, 0.1));\n  border-radius: 8px;\n  color: var(--success-color, #4caf50);\n  margin-bottom: 1rem;\n\n  .success-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.auth-expired {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: var(--error-bg, rgba(244, 67, 54, 0.1));\n  border-radius: 8px;\n  color: var(--error-color, #f44336);\n  margin-bottom: 1rem;\n\n  .expired-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.token-details {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  font-size: 0.8rem;\n\n  .token-detail-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .detail-label {\n      color: var(--text-secondary);\n      min-width: 60px;\n    }\n\n    .detail-value {\n      color: var(--text-primary);\n\n      &.expiring-soon {\n        color: var(--warning-color, #ff9800);\n      }\n\n      &.scopes {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 0.25rem;\n      }\n    }\n\n    .scope-chip {\n      background: var(--neutral-bg, rgba(128, 128, 128, 0.15));\n      padding: 0.15rem 0.5rem;\n      border-radius: 4px;\n      font-family: 'Fira Code', 'Consolas', monospace;\n      font-size: 0.7rem;\n    }\n  }\n}\n\n.advanced-option {\n  margin-top: 1.5rem;\n\n  mat-expansion-panel {\n    background: transparent;\n    box-shadow: none;\n    border: 1px solid var(--border-color);\n\n    mat-expansion-panel-header {\n      font-size: 0.875rem;\n      color: var(--text-secondary);\n    }\n  }\n}\n\n// Codex Device Auth Styles\n.device-auth-info {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 1rem;\n  margin: 1rem 0;\n\n  .device-url-row,\n  .device-code-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.75rem;\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n\n    .device-label {\n      color: var(--text-secondary);\n      font-size: 0.8rem;\n      min-width: 40px;\n    }\n\n    .device-url {\n      color: var(--link-color, #2196f3);\n      font-size: 0.875rem;\n      text-decoration: none;\n      word-break: break-all;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    .device-code {\n      font-family: 'Fira Code', 'Consolas', monospace;\n      font-size: 1.5rem;\n      font-weight: 600;\n      color: var(--primary-color, #1976d2);\n      letter-spacing: 0.1em;\n      background: var(--code-bg, rgba(0, 0, 0, 0.1));\n      padding: 0.25rem 0.75rem;\n      border-radius: 4px;\n    }\n\n    button {\n      flex-shrink: 0;\n    }\n  }\n\n  .device-note {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    margin: 1rem 0 0 0;\n    color: var(--text-secondary);\n    font-size: 0.8rem;\n    line-height: 1.4;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      flex-shrink: 0;\n      margin-top: 2px;\n      opacity: 0.7;\n    }\n  }\n}\n\n// Auth instructions (shared between Claude and Codex)\n.auth-instructions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin: 0 0 0.75rem 0;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: var(--success-color, #4caf50);\n    flex-shrink: 0;\n  }\n}\n\n.auth-code-field {\n  margin-top: 1rem;\n}\n\n.auth-error {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: var(--error-bg, rgba(244, 67, 54, 0.1));\n  border-radius: 8px;\n  color: var(--error-color, #f44336);\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n\n  mat-icon {\n    flex-shrink: 0;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.auth-actions {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 1rem;\n\n  button mat-spinner {\n    margin-right: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
